import type { FeedItem } from '../types/domain.types';

import { CtlApiError } from './errors';
import { request } from './http';
import { feedItemSchema, parseOrThrow } from './schemas';

const NOT_THEIRS = 404;

export const ISSUE_READ_PATH = (issueId: string): string => `/v2/notifications/issues/${encodeURIComponent(issueId)}`;

export const isIssueMissing = (error: unknown): boolean => error instanceof CtlApiError && error.status === NOT_THEIRS;

export const fetchIssue = async (issueId: string, signal: AbortSignal | undefined): Promise<FeedItem> => {
  const raw = await request('get', ISSUE_READ_PATH(issueId), { signal });
  return parseOrThrow(feedItemSchema, raw, 'issue');
};
